import React, { useState, useEffect, useMemo } from 'react';
import { object, func, bool } from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { ALERT_TYPE, ShowToastMessage, sequenceActionNext } from '@laramie/ui';
import { TableCustom, MessageModal } from '../../common';
import { CloneObject } from '../../../utils/helpers';
import { getBooleanToString } from '../../../utils/convert';
import { useEntidad } from '../../hooks/useEntidad';
import EmisionCuentaCorrienteModal from '../EmisionCuentaCorrienteModal';
import { isNull } from '../../../utils/validator';


const EmisionCuentasCorrientesGrid = (props) => {

  //hooks
  const [state, setState] = useState({
      idEmisionDefinicion: 0,
      disabled: false,
      showMessage: false,
      showForm: false,
      modeFormEdit: false,
      rowForm: null,
      listCuentasCorrientes: [],
      listCalculos: [],
      listFunciones: []
  });

  const dispatch = useDispatch();
  const sequenceValue = useSelector( (state) => state.sequence.value );

  const mount = () => {
    setState(prevState => {
      const listCuentasCorrientes = props.data.listCuentasCorrientes.filter(x => x.state !== 'r').sort((a, b) => a.orden - b.orden);
      return {...prevState,
        idEmisionDefinicion: props.data.idEmisionDefinicion,
        listCuentasCorrientes: listCuentasCorrientes,
        listCalculos: props.data.listCalculos,
        listFunciones: props.data.listFunciones
      };
    });
  }
  useEffect(mount, [props.data]);

  const [, getRowEntidad] = useEntidad({
    entidades: ['Tasa', 'SubTasa','TipoMovimiento'],
    onLoaded: (entidades, isSuccess, error) => {
      if (isSuccess) {
        setState(prevState => ({...prevState}));
      }
      else {
        ShowToastMessage(ALERT_TYPE.ALERT_ERROR, error);
      }
    },
    memo: {
      key: 'Tasa_SubTasa_TipoMovimiento',
      timeout: 0
    }
  });

  const cellA = (data) =>    <div className='action'>
                                {!props.disabled && (
                                  <div onClick={ (event) => handleClickEmisionCuentaCorrienteAdd() } className="link">
                                      <span className="material-symbols-outlined" title="Nuevo">add</span>
                                  </div>
                                )}
                              </div>
  const cellVMR = (data) =>  <div className='action'>
                                  <div onClick={ (event) => handleClickEmisionCuentaCorrienteView(data.value) } className="link">
                                  <span className="material-symbols-outlined" title="Ver">search</span>
                                  </div>
                                  {!props.disabled && !data.row.original.soloLectura && (
                                  <div onClick={ (event) => handleClickEmisionCuentaCorrienteModify(data.value) } className="link">
                                      <span className="material-symbols-outlined" title="Modificar">stylus</span>
                                  </div>
                                  )}
                                  {!props.disabled && !data.row.original.soloLectura && (
                                  <div onClick={ (event) => handleClickEmisionCuentaCorrienteRemove(data.value) } className="link">
                                      <span className="material-symbols-outlined" title="Eliminar">delete</span>
                                  </div>
                                  )}                                 
                              </div>

  const getDescTipoMovimiento = (id) => {
    const row = getRowEntidad('TipoMovimiento', id);
    return (row) ? row.nombre : '';
  }
  const getCodigoTasa = (id) => {
    const row = getRowEntidad('Tasa', id);
    return (row) ? row.codigo : '';
  }
  const getDescSubTasa = (id) => {
    const row = getRowEntidad('SubTasa', id);
    return (row) ? `${row.codigo} - ${row.descripcion}` : '';
  }


  const columnCabecera = useMemo(() =>
    (props.partidaUnificada) ? [
      { Header: 'Tasa cabecera', Cell: ({ value }) => getBooleanToString(value), accessor: 'tasaCabecera', width: '13%', disableSortBy: true }
    ] : []
  , [props.partidaUnificada]);

  const widthDescripcion = props.partidaUnificada ? '22%' : '24%';
  const widthSubTasa = props.partidaUnificada ? '27%' : '38%';

  const tableColumns = [
    { Header: 'Orden', accessor: 'orden', width: '6%', disableSortBy: true },
    { Header: 'Descripción', accessor: 'descripcion', width: widthDescripcion, disableSortBy: true },
    { Header: 'Movimiento', Cell: (props) => getDescTipoMovimiento(props.value), accessor: 'idTipoMovimiento', width: '13%', disableSortBy: true },
    { Header: 'Tasa', Cell: (props) => getCodigoTasa(props.value), accessor: 'idTasa', width: '6%', disableSortBy: true, ellipsis: false },
    { Header: 'Sub tasa', Cell: (props) => getDescSubTasa(props.value), accessor: 'idSubTasa', width: widthSubTasa, disableSortBy: true },
    { Header: 'Vto.', Cell: (props) => props.value === 0 ? "1-2" : props.value, accessor: 'vencimiento', width: '5%', disableSortBy: true },
    ...columnCabecera,
    { Header: cellA, Cell: cellVMR, id:'abm', accessor: 'id', width: '8%', disableGlobalFilter: true, disableSortBy: true }
  ];


  //handles
  const handleClickEmisionCuentaCorrienteAdd = () => {
    const idTemporal = (-1)*sequenceValue; //los registros temporales tienen id negativa
    setState(prevState => {
      const rowForm = {
        id: idTemporal,
        idEmisionDefinicion: state.idEmisionDefinicion,
        idTasa: 0,
        idSubTasa: 0,
        idTipoMovimiento: 0,
        tasaCabecera: !props.partidaUnificada,
        descripcion: "",
        formulaCondicion: "",
        formulaDebe: "",
        formulaHaber: "",
        vencimiento: 0,
        orden: 0,
        soloLectura: false,
        state: 'a'
      };
      return {...prevState, showForm: true, modeFormEdit: true, rowForm: rowForm};
    });
    dispatch( sequenceActionNext() );
  }
  const handleClickEmisionCuentaCorrienteView = (id) => {
    setState(prevState => {
      const rowForm = state.listCuentasCorrientes.find(x => x.id === id);
      return {...prevState, showForm: true, modeFormEdit: false, rowForm: rowForm};
    });
  }
  const handleClickEmisionCuentaCorrienteModify = (id) => {
    setState(prevState => {
      const rowForm = state.listCuentasCorrientes.find(x => x.id === id);
      return {...prevState, showForm: true, modeFormEdit: true, rowForm: rowForm};
    });
  }
  const handleClickEmisionCuentaCorrienteRemove = (id) => {
    setState(prevState => {
      const rowForm = state.listCuentasCorrientes.find(x => x.id === id);
      return {...prevState, showMessage: true, rowForm: rowForm};
    });
  } 

  //funciones
  function RemoveEmisionCuentaCorriente(row) {
    row.state = 'r';
    props.onChange('EmisionCuentaCorriente', row);
  }

  function UpdateEmisionCuentaCorriente(row) {
    row.state = isNull(state.listCuentasCorrientes.find(x => x.id === row.id)) ? 'a' : 'm';
    props.onChange('EmisionCuentaCorriente', row);
  }

  return (
  <>

    {state.showMessage && 
        <MessageModal
            title={"Confirmación"}
            message={"¿Está seguro de borrar el registro?"}
            onDismiss={() => {
              setState(prevState => {
                  return {...prevState, showMessage: false, rowForm: null};
              });
            }}
            onConfirm={() => {
              const row = CloneObject(state.rowForm);
              setState(prevState => {
                  return {...prevState, showMessage: false, rowForm: null};
              });
              RemoveEmisionCuentaCorriente(row);
            }}
        />
    }

    {state.showForm && 
        <EmisionCuentaCorrienteModal
            partidaUnificada={props.partidaUnificada}
            disabled={!state.modeFormEdit}
            data={{
              entity: state.rowForm,
              listCalculos: state.listCalculos,
              listFunciones: state.listFunciones
            }}
            onDismiss={() => {
              setState(prevState => {
                  return {...prevState, showForm: false, rowForm: null};
              });
            }}
            onConfirm={(row) => {
              setState(prevState => {
                  return {...prevState, showForm: false, rowForm: null};
              });
              UpdateEmisionCuentaCorriente(row);
            }}
            onMovePrevious={(state.rowForm && state.listCuentasCorrientes.some(f => f.orden < state.rowForm.orden)) ? () => {
              //tomo el primero de los menores ordenados de mayor a menor
              const idRowPrevious= state.listCuentasCorrientes.filter(f => f.orden < state.rowForm.orden).sort((a, b) => b.orden - a.orden)[0].id;
              if (state.modeFormEdit)
                handleClickEmisionCuentaCorrienteModify(idRowPrevious);
              else
                handleClickEmisionCuentaCorrienteView(idRowPrevious);
            } : null}
            onMoveNext={(state.rowForm && state.listCuentasCorrientes.some(f => f.orden > state.rowForm.orden)) ? () => {
              //tomo el primero de los mayores ordenados de menor a mayor
              const idRowNext = state.listCuentasCorrientes.filter(f => f.orden > state.rowForm.orden).sort((a, b) => a.orden - b.orden)[0].id;
              if (state.modeFormEdit)
                handleClickEmisionCuentaCorrienteModify(idRowNext);
              else
                handleClickEmisionCuentaCorrienteView(idRowNext);
            } : null}
        />
    }

    <TableCustom
        showFilterGlobal={false}
        className={'TableCustomBase'}
        columns={tableColumns}
        data={state.listCuentasCorrientes}
    />

  </>
  );
}

EmisionCuentasCorrientesGrid.propTypes = {
  disabled: bool,
  partidaUnificada: bool,
  data: object.isRequired,
  onChange: func.isRequired
};

EmisionCuentasCorrientesGrid.defaultProps = {
  disabled: false
};

export default EmisionCuentasCorrientesGrid;